// bill_subsystem_v1: bill app entry point
// - Renders BillLogin if no token
// - Otherwise renders BrowserRouter with bill routes
import React, { useState, useEffect } from 'react';
import billApi from './api'; /* bill_sso_v1 */
import { BrowserRouter, Routes, Route, Navigate, useOutletContext } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import BillLogin from './BillLogin';
import BillLayout from './BillLayout';
import BillDashboard from './pages/BillDashboard';
import BillInvoices from './pages/BillInvoices';
import BillCustomers from './pages/BillCustomers';
import BillProducts from './pages/BillProducts';
import BillFinance from './pages/BillFinance'; /* autofinance_ui_v1 */
import BillFinanceSummary from './pages/BillFinanceSummary'; /* autofinance_summary_ui_v1 */
import BillFinanceDashboard from './pages/BillFinanceDashboard'; /* finance_dashboard_v1 import */
import BillPayroll from './pages/BillPayroll'; /* payroll_v1 import */
import BillPartners from './pages/BillPartners'; /* partner_v1 import */
import BillBudget from './pages/BillBudget'; /* business_budget_v1 fe import */
import BillChannels from './pages/BillChannels'; /* bill_channels_v1 */
import BillUsers from './pages/BillUsers';
import BillBankAccounts from './pages/BillBankAccounts'; /* bank_promptpay_v1 */
import PaymentPage from './pages/PaymentPage'; /* payment_link_v1_public */

/* bill_smart_landing_v1 + smartlanding_fix_v1: landing redirect ตาม perm */
function SmartLanding() {
  var ctx = useOutletContext() || {};
  var mp = ctx.myPerms;
  if (!mp) return <div style={{ padding: 40, color: '#94a3b8' }}>กำลังโหลด…</div>;
  if (mp.is_owner || (mp.perms && mp.perms.dashboard && mp.perms.dashboard.view)) return <BillDashboard />;
  var order = [['summary', '/finance-dashboard'], ['transactions', '/finance'], ['invoices', '/invoices'], ['customers', '/customers'], ['products', '/products'], ['payroll', '/payroll'], ['partners', '/partners'], ['budget', '/budget'], ['channels', '/channels']];
  for (var i = 0; i < order.length; i++) { if (mp.perms && mp.perms[order[i][0]] && mp.perms[order[i][0]].view) return <Navigate to={order[i][1]} replace />; }
  return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>ยังไม่ได้รับสิทธิ์เข้าถึงเมนูใด — กรุณาติดต่อเจ้าของบัญชี</div>;
}

export default function BillApp() {
  const [user, setUser] = useState(function () {
    try { return JSON.parse(localStorage.getItem('bill_user') || 'null'); }
    catch (e) { return null; }
  });
  /* bill_sso_v1: consume #sso=<handoff> handed over from the chat app */
  const [ssoBusy, setSsoBusy] = useState(function () {
    try { return typeof window !== 'undefined' && (window.location.hash || '').indexOf('sso=') !== -1; }
    catch (e) { return false; }
  });
  useEffect(function () {
    var m = null;
    try { m = (window.location.hash || '').match(/sso=([^&]+)/); } catch (e) { m = null; }
    if (!m) return;
    var handoff = decodeURIComponent(m[1]);
    try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
    (async function () {
      try {
        var r = await billApi.post('/api/bill/auth/sso-exchange', { handoff: handoff });
        localStorage.setItem('bill_token', r.data.token);
        localStorage.setItem('bill_user', JSON.stringify(r.data.user));
        setUser(r.data.user);
      } catch (e) { /* fall through to login */ }
      finally { setSsoBusy(false); }
    })();
  }, []);
  /* bill_sso_v1: exchanging handoff -> show loader */
  if (ssoBusy) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: 15 }}>กำลังเข้าสู่ระบบบิล…</div>;
  }
  /* payment_link_v1_public: public route for /pay/:token (after hooks) */
  if (typeof window !== 'undefined' && window.location.pathname.indexOf('/pay/') === 0) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/pay/:token" element={<PaymentPage />} />
        </Routes>
      </BrowserRouter>
    );
  }
  const hasToken = !!localStorage.getItem('bill_token');

  if (!hasToken || !user) {
    return (
      <>
        <Toaster position="top-right" />
        <BillLogin onLoggedIn={setUser} />
      </>
    );
  }

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<BillLayout />}>
          <Route index element={<SmartLanding />} />
          <Route path="invoices" element={<BillInvoices />} />
          <Route path="customers" element={<BillCustomers />} />
          <Route path="channels" element={<BillChannels />} /> {/* bill_channels_v1 */}
          <Route path="products" element={<BillProducts />} />
          <Route path="bank-accounts" element={<BillBankAccounts />} /> {/* bank_promptpay_v1 */}
          <Route path="finance" element={<BillFinance />} /> {/* autofinance_ui_v1 */}
          <Route path="finance-summary" element={<BillFinanceSummary />} /> {/* autofinance_summary_ui_v1 */}
          <Route path="finance-dashboard" element={<BillFinanceDashboard />} /> {/* finance_dashboard_v1 route */}
          <Route path="payroll" element={<BillPayroll />} /> {/* payroll_v1 route */}
          <Route path="partners" element={<BillPartners />} /> {/* partner_v1 route */}
          <Route path="budget" element={<BillBudget />} /> {/* business_budget_v1 fe route */}
          <Route path="users" element={<BillUsers />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
